/** Next-active-date rollup for a parent level. An unlocked hierarchy row always shows the next active
 *  scheduled date underneath it — the earliest effective date on or after today, falling back to the
 *  earliest of all when every one of them is already behind us (the same rule the RA scope rows use).
 *  Completed work never supplies that date, and never makes a parent read MULTI. */
const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

/** Rows still in the live schedule — a finished room's frozen date must not surface on an active parent. */
export const activeRows = (rows) =>
  (rows || []).filter((r) => r && Number(r.percent_complete || 0) < 1 && !r.room_complete);

export const nextUpcoming = (dates) => {
  const vals = [...new Set((dates || []).filter(Boolean).map((d) => String(d).slice(0, 10)))].sort();
  if (!vals.length) return { date: "", past: false };
  const up = vals.filter((v) => v >= todayIso());
  return up.length ? { date: up[0], past: false } : { date: vals[0], past: true };
};

/** The summary for one field across one node's rows: `{ date, past }` ("" when nothing is scheduled). */
export const mixedSummary = (rows, field) => {
  const pool = activeRows(rows);
  return nextUpcoming((pool.length ? pool : rows || []).map((r) => r?.[`eff_${field}`]));
};
